import './AddAppSettings.scss';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag, StakeholderType } from '@sonar-software/sonar-core';
import { Form, Input, Tag } from 'antd';
import { APP_VALIDATION_RULES } from '../../@arch/validation';
import { AddAppSection } from '../add-app';
import { AppActivityPeriodSelect } from './AppActivityPeriodSelect';
import { AppUserSelect } from './AppUserSelect';
import { ClassificationSelector } from '@ui/tags';
import { FeatureBoundary } from '@ui/features';
import React from 'react';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import TextArea from 'antd/es/input/TextArea';
import { UserSelector } from '@ui/UserSelector';
import { useFeatureFlag } from '@hooks';
export const AddAppSettings = ({ applicationName, form, onFinish, onValuesChange, validator }) => {
    const hasEventMonitoring = useFeatureFlag(FeatureFlag.DataSecurityDashboard);
    return (React.createElement(AddAppSection, { className: 'add-app-settings-section', title: COPY_SPECIFIC.ADD_APP_SETTINGS },
        React.createElement(Form, { className: 'add-app-settings-form', form: form, layout: 'vertical', onFinish: onFinish, onValuesChange: onValuesChange },
            React.createElement(Form.Item, { className: 'app-display', id: 'app-name', label: COPY_SPECIFIC.NAME, name: 'name', rules: [
                    ...APP_VALIDATION_RULES.NAME,
                    {
                        validator: validator
                    }
                ] },
                React.createElement(Tag, { className: 'application-name' }, applicationName)),
            React.createElement(Form.Item, { id: 'app-user', label: COPY_SPECIFIC.INTEGRATION_USER, name: 'user' },
                React.createElement(AppUserSelect, { allowClear: true, disabled: !hasEventMonitoring, disableUsed: true })),
            React.createElement(Form.Item, { id: 'app-label', label: COPY_SPECIFIC.LABEL, name: 'label', rules: [
                    ...APP_VALIDATION_RULES.LABEL,
                    {
                        validator: validator
                    }
                ] },
                React.createElement(Input, { placeholder: PLACEHOLDERS_COPY.APP_LABEL })),
            React.createElement(Form.Item, { id: 'app-description', label: COPY_SPECIFIC.DESCRIPTION, name: 'description', rules: APP_VALIDATION_RULES.DESCRIPTION },
                React.createElement(TextArea, { placeholder: PLACEHOLDERS_COPY.APP_DESCRIPTION })),
            React.createElement(Form.Item, { id: 'app-owner', label: COPY_SPECIFIC.OWNER, name: 'owner' },
                React.createElement(UserSelector, { allowClear: true, avatar: true, placeholder: PLACEHOLDERS_COPY.ADD_OWNER })),
            React.createElement(Form.Item, { id: 'app-stakeholder', label: COPY_SPECIFIC.STAKEHOLDERS, name: 'stakeholderIds' },
                React.createElement(StakeholderSelector, { direction: 'horizontal', mode: 'multiple', placeholder: COPY_SPECIFIC.ADD_STAKEHOLDERS })),
            React.createElement(Form.Item, { id: 'app-group', label: COPY_SPECIFIC.GROUP, name: 'group' },
                React.createElement(StakeholderSelector, { placeholder: PLACEHOLDERS_COPY.SELECT_APP_GROUP, stakeholderType: StakeholderType.Team })),
            React.createElement(Form.Item, { id: 'app-classification', label: COPY_SPECIFIC.CLASSIFICATION, name: 'classification' },
                React.createElement(ClassificationSelector, { isSpreadsheet: true })),
            React.createElement(FeatureBoundary, { feature: FeatureFlag.DataSecurityDashboard },
                React.createElement(Form.Item, { id: 'app-activity-period', initialValue: 7, label: COPY_SPECIFIC.OBJECT_AND_FIELD_USAGE_ACTIVITY, name: 'activityPeriod' },
                    React.createElement(AppActivityPeriodSelect, null))))));
};
